// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"99e90796","455":"7aaf65cb","977":"d2d416d9"}[chunkId] + ".chunk.js";
};